import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Form = styled.form<{ $isSidebarExpanded: boolean }>`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  width: var(--chat-message-width);
`;

export const DropdownHeader = styled.h3`
  ${typographyV2.titleSm};
  background: var(--surface-hover);
  color: var(--text-soft);
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-soft);
`;
